import React, { useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import PlantCircle from '../../Graphics/PlantCircle'
import Check from '../../Graphics/SelectionCheckIcon'

// HOC
import withAppStore from '../../../../util/withAppStore'

import styles from '../../../../../css/timeblock.module.css'

const MINUTES_MAXIMUM = 7 * 24 * 60

const EventBlock = ({
  event,
  handleUpdateEvent,
  fertigation,
  outletID,
  isSelect,
  selected,
  level,
}) => {
  const [selectedState, setSelectedState] = useState(false)

  // Calculate dates and times using useMemo for performance
  const { startUTC, stopUTC, noLater, dates, times, duration } = useMemo(() => {
    const weekB = moment.utc().startOf('week')
    let stopRing = event.stop
    if (event.stop < event.start) stopRing = event.stop + MINUTES_MAXIMUM

    const startUTC = moment(weekB).add(event.start, 'minutes').toISOString()
    const stopUTC = moment(weekB).add(stopRing, 'minutes').toISOString()

    let noLater = false
    if (moment().unix() < Number(event.noLater)) {
      noLater = moment.unix(event.noLater).format('LLL')
    }

    // Calculate dates
    const start = moment(startUTC).format('ddd h:mm A')
    const stop = moment(stopUTC).format('ddd h:mm A')
    const dates = start === stop ? start : `${start} to ${stop}`

    // Calculate times
    let times = 'Repeats: Indefinitely'
    if (noLater) {
      times = `Repeats Until: ${noLater}`
    }

    // Calculate duration
    const startMoment = moment(startUTC)
    const stopMoment = moment(stopUTC)
    const dur = moment.duration(stopMoment.diff(startMoment))
    const duration = `Run Time: ${Math.floor(dur.asHours())} Hr ${dur.minutes()} Min`

    return { startUTC, stopUTC, noLater, dates, times, duration }
  }, [event])

  const handleClick = (e) => {
    e.stopPropagation()
    if (level >= 10) {
      if (isSelect) {
        selected(event, outletID)
        setSelectedState(!selectedState)
      } else {
        handleUpdateEvent(event, outletID)
      }
    }
  }

  const handleKeyPress = (e) => {
    e.stopPropagation()
    if (e.key !== 'Enter') {
      return
    }
    if (level >= 10) {
      if (isSelect) {
        selected(event, outletID)
        setSelectedState(!selectedState)
      } else {
        handleUpdateEvent(event, outletID)
      }
    }
  }

  return (
    <div
      className={`${styles.event}`}
      style={{ height: '80px' }}
      onMouseDown={(e) => e.stopPropagation()}
      role='button'
      tabIndex='0'
      onClick={handleClick}
      onKeyPress={handleKeyPress}
    >
      {isSelect && selectedState &&
      (
        <div style={{ position: 'absolute', width: '30px', height: '30px', right: '10px', top: '10px' }}><Check /></div>
      )}
      <div className={styles.event_times}>{dates}</div>
      <div className={styles.event_times}>{duration}</div>
      <div className={styles.event_times}>{times}</div>
      {fertigation && (
        <PlantCircle style={{
          position: 'absolute', width: '30px', height: '30px', right: '10px', bottom: '10px',
        }}
        />
      )}
    </div>
  )
}

EventBlock.propTypes = {
  event: PropTypes.object.isRequired,
  handleUpdateEvent: PropTypes.func.isRequired,
  fertigation: PropTypes.bool,
  outletID: PropTypes.string,
  isSelect: PropTypes.bool,
  selected: PropTypes.func,
  level: PropTypes.number.isRequired,
}

export default withAppStore(EventBlock)
